"use client";

import type React from "react";
import { type ReactNode, useContext } from "react";
import { Box } from "../Box/Box";
import { ColumnsContext } from "../Columns/Columns";
import styles from "./Column.module.css";

export interface ColumnProps {
  children?: ReactNode;
  width?:
    | "1/2"
    | "1/3"
    | "2/3"
    | "1/4"
    | "3/4"
    | "1/5"
    | "2/5"
    | "3/5"
    | "4/5"
    | "content";
}

export const Column = ({ children, width }: ColumnProps): React.ReactNode => {
  const {
    collapseMobile,
    collapseTablet,
    mobileSpace,
    tabletSpace,
    desktopSpace,
  } = useContext(ColumnsContext);

  return (
    <Box
      minWidth={0}
      width={width !== "content" ? "full" : undefined}
      flexShrink={width === "content" ? 0 : undefined}
      className={[
        styles.column,
        width && width !== "content"
          ? styles[`width-${width.replace("/", "_")}`]
          : null,
      ]}
    >
      <Box
        paddingLeft={[
          collapseMobile ? "none" : mobileSpace,
          collapseTablet ? "none" : tabletSpace,
          desktopSpace,
        ]}
        paddingTop={
          collapseMobile || collapseTablet
            ? [
                collapseMobile ? mobileSpace : "none",
                collapseTablet ? tabletSpace : "none",
                "none",
              ]
            : undefined
        }
        height="full"
        className={styles.columnContent}
      >
        {children}
      </Box>
    </Box>
  );
};
